<div class="float-drag" cdkDrag>
    <div class="float-container">
        <div class="float-header" cdkDragHandle>
            <div class="header-text">
                Line Split
            </div>
            <!-- <i class="glyphicons glyphicons-remove" (click)="close()"></i> -->
        </div>



        <!-- <div class="line-split-title">
            Line Split
        </div> -->
        <div class="line-split-wrap">
            <div class="range-adjust">
                <ng-container *ngFor="let split of splits; let idx = index;">
                    <app-line-with-measure [rec]="split" [splitIdx]="idx" (jointChange)="jointChange($event)"></app-line-with-measure>
                </ng-container>
            </div>
            <div class="line-columns">
                <div class="column-item">
                    <div></div>
                    <div class="column-left-right" *ngFor="let split of splits; let idx = index;">
                        <div class="column-value">
                            Split {{idx + 1}}
                        </div>
                    </div>
                </div>
    
                <div class="column-item">
                    <div></div>
                    <div class="column-left-right" *ngFor="let split of splits;">
                        <div class="column-value">
                            Left
                        </div>
                        <div class="column-value">
                            Right
                        </div>
                    </div>
                </div>
    
                <div class="column-item" *ngFor="let col of cols; let idx = index">
                    <div>{{col.neutralName}}</div>
                    <div class="column-left-right" *ngFor="let split of splits; let idx2 = index;">
                        <div class="column-value">
                            <app-feat-edit-cell
                                [(cellValue)]="split[col.leftProp]"
                                [column]="{prop: col.leftProp, isUppercase: col.standardLeft.isUppercase}"
                                [domainsByColumn]="domainsByColumn"
                                (valueChange)="onEditAttr(idx2, col.leftProp)"
                            ></app-feat-edit-cell>
                            <!-- <input name="left-{{idx}}-{{idx2}}" [(ngModel)]="split[col.leftProp]" (ngModelChange)="onEditAttr(idx2, col.leftProp)"> -->
                        </div>
                        <div class="column-left-right" class="column-value">
                            <app-feat-edit-cell
                                [(cellValue)]="split[col.rightProp]"
                                [column]="{prop: col.rightProp, isUppercase: col.standardRight.isUppercase}"
                                [domainsByColumn]="domainsByColumn"
                                (valueChange)="onEditAttr(idx2, col.rightProp)"
                            ></app-feat-edit-cell>
                            <!-- <input name="right-{{idx}}-{{idx2}}" [(ngModel)]="split[col.rightProp]" (ngModelChange)="onEditAttr(idx2, col.rightProp)"> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="float-popup-footer">
            <div class="button-groups">
                <button class="button-general" (click)="cancel()">Cancel</button>
                <button class="button-general" (click)="apply()">Apply</button>
            </div>
        </div>



    </div>
</div>
